<div class="mh-300 views-container mt-0">
  <mat-dialog-content>
    <div class="mw-450">
      <h4>{{ 'BO_ANPR_ADDRECORD_TITLE' | translate }}</h4>
      <p>{{ data.npId }}</p>
      <form [formGroup]="anprForm" autocomplete="off">
        <div class="form-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'BO_ANPR_TYPE' | translate }}</mat-label>
            <mat-select formControlName="anpRecordType">
              @for (type of recordTypes; track type) {
                <mat-option [value]="type">
                  {{ 'BO_ANPR_' + type | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'BO_ANPR_INFO' | translate }}</mat-label>
            <input matInput type="text" formControlName="info">
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" class="btn btn-secondary mr-auto">
    {{ 'BO_CANCEL' | translate }}
  </button>
  <button mat-button (click)="submitForm(anprForm.getRawValue())" [disabled]="!anprForm.valid"
    class="btn btn-primary ml-auto">
    {{ 'BO_CONFIRM' | translate }}
  </button>
</div>